export enum ModuleType {
  AddressBook = 'ab',
  Opportunity = 'opp',
  Lead = 'lead',
  Case = 'cs',
  Task = 'task',
  OpportunityViewer = 'pipeline',
  CaseViewer = 'caseViewer',
  AppDirectory = 'itgNew',
}
